import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import common from "../../constants/common";

import {
  API_CREDIT_PATH,
  create,
  edit,
  remove,
  detail,
  getAllCredits,
  getCreditsByClient,
  getCreditsMasseClient,
  updateMasse,
  removeCategory,
  API_CREDIT_CATEGORY_PATH,
  createCategory,
  editCat,
  creditPayFast,
  creditTransform,
  getListTransactions,
  updateTransactions,
  getStatistic
} from "../../services/credit";
import { API_TRANSACTION_PATH } from "../../services/transaction";

const initialState = {
  list: [],
  metaData: {},
  listByClient: [],
  listTrans: [],
  credit: {},
  listOnTime: [],
  listDelay: [],
  statistic: {}
};

export const statisticData = createAsyncThunk(
  `${API_CREDIT_PATH}/statistic`,
  async () => getStatistic()
);

export const getCreditDetail = createAsyncThunk(
  `${API_CREDIT_PATH}/${common.detail}`,
  async id => {
    const res = await detail(id);
    return res;
  }
);
export const getCreditList = createAsyncThunk(
  `${API_CREDIT_PATH}/${common.list}`,
  async () => {
    const res = await getAllCredits();
    return res;
  }
);
export const getCreditListByClient = createAsyncThunk(
  `${API_CREDIT_PATH}/list-by-client`,
  async (filter = "") => {
    const res = await getCreditsByClient(filter);
    return res;
  }
);
export const getListCreditOnTime = createAsyncThunk(
  `${API_CREDIT_PATH}/list-on-time`,
  async () => {
    const res = await getCreditsByClient("?status=ontime");
    return res;
  }
);
export const getListCreditDelay = createAsyncThunk(
  `${API_CREDIT_PATH}/list-delay`,
  async () => {
    const res = await getCreditsByClient("?status=delay");
    return res;
  }
);

export const getCreditListMasseClient = createAsyncThunk(
  `${API_CREDIT_PATH}/list-by-client`,
  async clientId => {
    const res = await getCreditsMasseClient(clientId);
    return res;
  }
);

export const createNewCredit = createAsyncThunk(
  `${API_CREDIT_PATH}/create`,
  async credit => {
    const res = await create(credit);
    return { ...res, credit };
  }
);
export const createNewCreditCat = createAsyncThunk(
  `${API_CREDIT_CATEGORY_PATH}/${common.create}`,
  async credit => {
    const res = await createCategory(credit);
    return { ...res, credit };
  }
);

export const editCredit = createAsyncThunk(
  `${API_CREDIT_PATH}/${common.edit}`,
  async credit => {
    const res = await edit(credit);
    return res;
  }
);

export const editCreditCat = createAsyncThunk(
  `${API_CREDIT_CATEGORY_PATH}/${common.edit}`,
  async credit => {
    const res = await editCat(credit);
    return { credit, res };
  }
);

export const deleteCredit = createAsyncThunk(
  `${API_CREDIT_CATEGORY_PATH}/${common.delete}`,
  async id => {
    const res = await remove(id);
    return { ...res };
  }
);

export const creditTransformSlice = createAsyncThunk(
  `${API_CREDIT_CATEGORY_PATH}/credit-transform`,
  async ({ creditId, data }) => {
    const res = await creditTransform(creditId, data);
    return { ...res };
  }
);

export const closeCredit = createAsyncThunk(
  `${API_CREDIT_PATH}/close-credit`,
  async credit => {
    const res = await edit(credit);
    return res;
  }
);

export const deleteCreditCategory = createAsyncThunk(
  `${API_CREDIT_CATEGORY_PATH}/${common.delete}`,
  async id => {
    await removeCategory(id);
  }
);

export const updateMasseCredit = createAsyncThunk(
  `${API_CREDIT_PATH}/update-masse-credit`,
  async data => {
    await updateMasse(data);
  }
);

export const listTransactions = createAsyncThunk(
  `${API_CREDIT_PATH}/list-transaction`,
  async loanId => getListTransactions(loanId)
);
export const updateTransactionSlice = createAsyncThunk(
  `${API_CREDIT_PATH}/updateTransaction`,
  async (transactionId, data) => updateTransactions(transactionId, data)
);
export const creditPayFastSlice = createAsyncThunk(
  `${API_TRANSACTION_PATH}/creditPayFast`,
  async (creditId, data) => creditPayFast(creditId, data)
);
export const creditSlice = createSlice({
  name: "credit",
  initialState,
  reducers: {
    setStatisticData: (state, { payload }) => {
      state.statistic = payload;
    },
    setCredit: (state, { payload }) => {
      state.credit = payload;
    },
    setCreditList: (state, { payload }) => {
      state.list = payload;
    },
    setMasseList: (state, { payload }) => {
      state.listByClient = payload;
    },
    setListTrans: (state, { payload }) => {
      state.listTrans = payload;
    },

    setDelayList: (state, { payload }) => {
      state.listDelay = payload;
    }
  },
  extraReducers: {
    [statisticData.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.statistic = payload?.data?.data || {};
      }
    },
    [getCreditList.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data, metaData } = payload.data;
        state.list = data;
        state.metaData = metaData;
      }
    },
    [getCreditListByClient.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data, metaData } = payload.data;
        state.listByClient = data;
        state.metaData = metaData;
      }
    },
    [getListCreditOnTime.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        state.listOnTime = data;
      }
    },
    [getListCreditDelay.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        state.listDelay = data;
      }
    },
    [createNewCredit.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.list.push(payload.credit);
      }
    },
    [getCreditDetail.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        state.credit = data;
      }
    },
    [listTransactions.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        state.listTrans = data;
      }
    },
    [updateTransactionSlice.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        console.log(data);
        // state.listTrans = data;
      }
    },
    [creditPayFastSlice.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        console.log(data);
        // state.listTrans = data;
      }
    },
    [creditTransformSlice.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        console.log(data);
        // state.listTrans = data;
      }
    }
    // [closeCredit.fulfilled]: (state, { payload }) => {
    //   if (payload.status) {
    //     // console.log("1111");
    //     const { data } = payload.data;
    //     console.log(data);
    //   }
    // },
  }
});

export const {
  setCredit,
  setCreditList,
  setMasseList,
  setListTrans,
  setDelayList
} = creditSlice.actions;

export default creditSlice.reducer;
